export default {
  namespaced: true,
  state: {
    defaultNotification: {
      title: null,
      message: '',
      typeOfMessage: 'ALERT', // ALERT, NOTIFICATION
      type: null, // danger, info, warning
      isViewed: false,
      isCanRetry: false,
      retryTitle: 'Retry',
      retryCallback: null,
      dismissTitle: 'OK',
      details: null,
      errorCode: null
    },
    notifications: []
  },
  mutations: {
    'ADD_NOTIFICATION' (state, payload) {
      state.notifications.push(payload)
    },
    'REMOVE_NOTIFICATION' (state, index) {
      state.notifications.splice(index, 1)
    }
  },
  actions: {
    add ({state, commit}, payload) {
      const vueInstance = payload.vueInstance
      delete payload.vueInstance
      const data = Object.assign(state.defaultNotification, payload)
      commit('ADD_NOTIFICATION', data)
      if (data.typeOfMessage === 'ALERT') {
        vueInstance.$modal.show('alertmodal', data)
      }
    },
    remove ({commit}, payload) {
      commit('REMOVE_NOTIFICATION', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/notifications.js